import { IDicomWriter } from 'app/interfaces/IDicomWriter';
import React from 'react';

const DicomWriterContext = React.createContext<IDicomWriter>(undefined);

export default DicomWriterContext;
